import { Component, HostBinding, Input, Output, EventEmitter, output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DisplayedColumns, EdTableComponent } from '../ed-table/ed-table.component';
import { CommonModule } from '@angular/common';
import { GenericCardComponent } from '../generic-card/generic-card.component';
import { SkeletonListComponent } from '../skeleton-list/skeleton-list.component';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'table-card',
    templateUrl: './table-card.component.html',
    styleUrls: ['./table-card.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        GenericCardComponent,
        SkeletonListComponent,
        MatMenuModule,
        EdTableComponent,
    ],
})
export class TableCardComponent {
    @Input() title: string | undefined;
    @Input() descriptionTitle?: string;
    @Input() descriptionContent?: string;
    @Input() dataSource!: MatTableDataSource<any>;
    @Input() displayedColumns: DisplayedColumns[] = [];
    @Input() areActionsInElements: boolean = false;

    @Input() error: boolean = false;
    @Input() isLoading: boolean = true;
    @Input() cardClass: string = '';
    @Input() filter: string = '';
    @Input() sortInfo: { field: string; order: number } | undefined;

    @Input() totalCount: number = 0;
    @Input() pageSize: number = 0;
    @Output() onPageChange = new EventEmitter<number>();

    @Output()
    public onRowClick = new EventEmitter<number>(); // id of the row item
    @Output()
    public onDropdownMenuClick = new EventEmitter<any>();

    @Output()
    public onSortChanged = new EventEmitter<any>();

    // Bind the cardClass property to the class attribute of the host element
    @HostBinding('class') get hostClasses(): string {
        return this.cardClass;
    }

    constructor() {}

    public onRowClickEvent(id: number): void {
        this.onRowClick.emit(id);
    }

    public onDropdownMenuClickEvent(event: { object: any; event: any }) {
        this.onDropdownMenuClick.emit(event);
    }

    public export() {
        const data = this.dataSource.data;
        const filename = (this.title || 'export') + '.csv';
        if (!data || !data.length) {
            console.warn('Aucune donnée à exporter');
            return;
        }

        // 1. Construire les lignes
        const csvRows = [
            this.displayedColumns.map((d) => d.objectDisplayName).join(';'), // première ligne : en-têtes séparés par ";"
            ...data.map((row) =>
                this.displayedColumns
                    .map((d) => d.objectKey)
                    .map((field) => {
                        let val = row[field] ?? '';
                        // Escape des guillemets et remplacement des retours à la ligne
                        val = String(val).replace(/"/g, '""').replace(/\n/g, ' ');
                        return `"${val}"`;
                    })
                    .join(';'),
            ),
        ];

        // 2. Fusionner en une seule string
        const csvContent = csvRows.join('\n');

        // 3. Créer un blob et déclencher le téléchargement
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Libérer l’URL
        window.URL.revokeObjectURL(url);
    }

    onPageClick(page: number) {
        this.onPageChange.emit(page);
    }
}
